module.exports = __webpack_public_path__ + "img/face_dis.439a865e.png";